export default __webpack_public_path__ + "static/media/李宏毅.5deb65ee.jpg";